import { delegationPersonName, type ActionCard } from '@littlebird/sdk';

import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { useReceivedDelegationFor } from '../action-card-delegation.query';

import type { ReactNode } from 'react';

type DelegationLineProps = {
  readonly label?: ReactNode;
  readonly note: string | null;
  readonly className?: string;
};

export const DelegationLine = ({
  label,
  note,
  className,
}: DelegationLineProps) => {
  if (!label && !note) return null;

  return (
    <XStack
      data-find-exclude
      className={cn(
        'min-w-0 items-baseline gap-1.5 text-sm text-foreground-muted',
        className
      )}
    >
      <Icons.user className="size-3 shrink-0 self-center" aria-hidden="true" />
      {label ? <span className="shrink-0">{label}</span> : null}
      {note ? (
        <span className="truncate italic" title={note}>
          “{note}”
        </span>
      ) : null}
    </XStack>
  );
};

type ReceivedDelegationLineProps = {
  readonly card: Pick<ActionCard, 'id' | 'origin' | 'chatId'>;
  readonly className?: string;
};

export const ReceivedDelegationLine = ({
  card,
  className,
}: ReceivedDelegationLineProps) => {
  const received = useReceivedDelegationFor(card);
  if (!received) return null;

  return (
    <DelegationLine
      className={className}
      label={
        <>
          Sent to you by{' '}
          <span className="text-foreground-subtle">
            {delegationPersonName(received.delegatedBy)}
          </span>
        </>
      }
      note={received.note}
    />
  );
};
